<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate('tariffed_device.modal_complete_tariffication.title') }}
      </h4>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <WrapDatePicker
              v-model="data.date_end"
              type="date"
              :range="false"
              value_type="YYYY-MM-DD"
              :confirm="false"
              :clearable="true"
              :disabled_date="[date_order_started, '+ 2 month']"
              :label="translate('tariffed_device.modal_complete_tariffication.date_end')"
              :placeholder="translate('tariffed_device.modal_complete_tariffication.date_end')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <fg-input
              v-model="data.diadoc_url"
              type="text"
              :label="translate('tariffed_device.modal_complete_tariffication.deactivation_diadoc_url')"
              :placeholder="translate('tariffed_device.modal_complete_tariffication.deactivation_diadoc_url')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="filter checkbox">
            <div class="info">
              {{ translate('tariffed_device.modal_complete_tariffication.create_deactivation_request_at_expiration') }}
            </div>
            <label
                class="switch"
                :class="{ 'no-user-access': !can_create_request_deactivation }"
                @click.prevent="data.create_deactivation_request_at_expiration = !data.create_deactivation_request_at_expiration"
            >
              <input type="checkbox" v-model="data.create_deactivation_request_at_expiration" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="col-md-6">
          <div class="filter checkbox">
            <div class="info">
              {{ translate('tariffed_device.modal_complete_tariffication.block_device_at_expiration') }}
            </div>
            <label class="switch" @click.prevent="data.block_device_at_expiration = !data.block_device_at_expiration" >
              <input type="checkbox" v-model="data.block_device_at_expiration" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>


      <div class="text-center buttons">
        <span
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="complete_tariffing"
            :disabled="data.date_end === null"
        >
          {{ translate("btn.edit") }}
        </span>
        <span
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
        >
          {{ translate("btn.close") }}
        </span>
      </div>
      <div class="clearfix"/>
    </div>
  </div>
</template>
<script>

import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: "CompleteTariffing",
  components:{
    WrapDatePicker
  },
  data() {
    return {
      data:{
        date_end: null,
        create_deactivation_request_at_expiration: false,
        block_device_at_expiration: false,
        diadoc_url: ""
      }
    }
  },
  props: {
    can_create_request_deactivation:{
      type: [Boolean],
      default: false
    },
    id: {
      type: [Number],
      default: null
    },
    date_order_started:{
      type: Number,
      default: null
    }
  },

  methods: {
    complete_tariffing(){
      if (this.data.date_end === null) return
      let params = {
        id: this.id,
        date_end: this.data.date_end,
        create_deactivation_request_at_expiration: Number(this.data.create_deactivation_request_at_expiration),
        block_device_at_expiration: Number(this.data.block_device_at_expiration),
        diadoc_url: this.data.diadoc_url
      }
      this.$http.v1.stopDeviceTariffication(params, () => {
        this.global_notify("info", this.translate("tariffed_device.modal_complete_tariffication.completed_successfully"));
        this.$emit('update')
      })
    },
    cancel() {
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
.modal_card {
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    .title {
      margin-top: 5px;
      text-align: center;
    }
  }

  .content {
    .row {
      margin-bottom: 10px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      .icon{
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        span.mdi{
          font-size: 20px;
          &.online{
            color: #15ab00;
          }
          &.tariffication{
            color: #3f93d3;
          }
        }
      }

      .mx-input {
        width: 100%;
      }

      .form-group {
        margin: 0;
      }
    }
  }
  .buttons{
    .btn {
      height: 40px;
      margin-right: 5px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
}

</style>
